import { render, staticRenderFns } from "./ReceivedBadge.vue?vue&type=template&id=02f5ab7a"
var script = {}
import style0 from "./ReceivedBadge.vue?vue&type=style&index=0&id=02f5ab7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports